import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import '@maersk-global/mds-components-core/mc-button';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslocoModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
  title = 'mec-carrier-integration-ui';
  configuration = `Region: ${environment.region}\nEnvironment: ${
    environment.production ? 'production' : 'development'
  }`;

  constructor() {}

  ngOnInit(): void {
  }
}
